import type { GuidanceSessionType } from '../guidance-session/GuidanceSession';

export enum GuideStatus {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    LEFT_COMPANY = 'LEFT_COMPANY',
}

export interface Guide {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    pronouns?: string | null;
    signUpId?: string | null;
    profileImageUrl?: string | null;
    sendbirdUserId?: string | null;
    status: GuideStatus;
    guideBookingLinks?: GuideBookingLink[] | null;
    bio?: string | null;
    styles?: string | null;
    createdAt: Date;
    updatedAt: Date | null;
}

export interface GuideBookingLink {
    id: string;
    guideId: string;
    type: GuidanceSessionType;
    bookingLink: string;
    createdAt: Date;
    updatedAt: Date | null;
}
